import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
export const DonationInfo = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="pb-8 font-700 text-Gray-600 typo-body4">고향사랑기부제 고객센터</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ul className="flex flex-col gap-4 pb-8 font-400 text-Gray-600 typo-body4"><li>전화 : <a href="tel:1833-9363">1833-9363</a></li><li>운영시간 : 월~금요일 오전 10시 ~ 오후 5시</li><li>고객센터 운영시간에 순차적으로 답변드리겠습니다.</li></ul>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col">{t0}{t1}<ul className="flex items-center gap-4"><li><Button theme="sub-line" dimensions="H26" asChild={true} className="bg-Gray-white"><a aria-label={"\uC81C\uD734 \uBC0F \uC9C0\uC790\uCCB4 \uC785\uC810 \uBB38\uC758 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} href="https://forms.gle/gZjgg76YpXcWgw2p9" rel="noreferrer" target="_blank">제휴 및 지자체 입점 문의</a></Button></li></ul></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};